import React from "react";
import { Link } from "react-router-dom";

const ComingSoon = () => {
  return (
    <div className="container-fluid problems newdetails">
      <div className="row">
        <div className="col-md-10 mx-auto">
          <div className="row">
            <div className="col-md-6 col-sm-12 order-md-1 order-2 my-auto para">
              <h2>Obsessed with Us ?</h2>
              <p className="para">
                Don't worry we are coming with much more awesome content very
                very soon
              </p>
              <button className="cbtn">
                <Link to="/">Home</Link>
              </button>
            </div>
            <div className="col-md-6 col-sm-12 order-md-2 order-1 mt-5">
              <img
                src={require("../images/rename.svg")}
                alt=""
                className="img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
